import { BASE_PUBLIC_ASSETS_URL } from "@dtm-frontend/shared/utils";

export const BROCHURE_FILE = `${BASE_PUBLIC_ASSETS_URL}/Broszura_KPO.pdf`;
